import React from 'react';
import '../../../styles/GenericSiteStyles.scss';

interface SubsectionPanelProps {
  title: string;
  actions?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

const SubsectionPanel: React.FC<SubsectionPanelProps> = ({ title, actions, className = '', children }) => (
  <section className={`subsection-panel card-glass project-tab-section ${className}`.trim()} style={{ maxWidth: '100vw', overflowX: 'hidden' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <h4 className="section-title">{title}</h4>
      {actions}
    </div>
    <div className="subsection-panel-content">
      {children}
    </div>
  </section>
);

export default SubsectionPanel;
